import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import ProfileSceneUserView from '@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserView'
import ProfileSceneUserEdit from '@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserEdit'
import { StoresContext } from '@App/contexts'
import RootStore from '@App/stores/root-store'
import { userinfoToZodMapper } from '@App/helpers/userinfo-to-zod-mapper'
import { internationalPhoneNumberSchema } from '@Entities/schemas/common/international-phone-number-schema'

const isUserPhoneInvalid = (phoneNumber: { phoneCountryCode: string; fullPhoneNumber: string }): boolean =>
    !internationalPhoneNumberSchema.safeParse(phoneNumber).success

const ProfileSceneUserTab = observer(() => {
    const { userStore } = useContext<RootStore>(StoresContext)

    const phoneInvalid = !!userStore.userInfo && isUserPhoneInvalid(userinfoToZodMapper(userStore.userInfo).phoneNumber)

    const [isEditable, setEditable] = useState(phoneInvalid)

    return (
        <>
            {isEditable ? (
                <ProfileSceneUserEdit setEditable={setEditable} initialPhoneInvalid={phoneInvalid} />
            ) : (
                <ProfileSceneUserView setEditable={setEditable} />
            )}
        </>
    )
})

export default ProfileSceneUserTab
